const actions = {
  setBannerAds({ commit }, payload) {
    commit('SET_BANNER_ADS', payload);
  },
};

const mutations = {
  /* eslint-disable no-param-reassign */
  SET_BANNER_ADS(state, payload) {
    state.bannerAds = payload;
  },
  /* eslint-enable no-param-reassign */
};

const getters = {
  getBannerAds: state => pagina => state.bannerAds[pagina],
};

const state = {
  bannerAds: '',
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
